import { Curso } from '../curso'

export const eCursoSegundaFase = (curso: Curso) => {
  return curso?.secondPhaseExerciseExists ?? false
}
